import { makeStyles } from "@material-ui/core";

export const useTextfieldStyles = makeStyles((theme) => ({
  root: {
    "& label": {
      color: "green",
    },
    "& .MuiInputLabel-outlined + fieldset": {
      color: "green",
    },
    "& label.Mui-focused": {
      color: "green",
    },
    "& p": {
      color: "green",
    },
    "& input:valid + fieldset": {
      borderColor: "green",
      borderWidth: 2,
    },
    "& input:invalid + fieldset": {
      borderColor: "red",
      borderWidth: 2,
    },
    "& input:valid:focus + fieldset": {
      borderColor: "green",
      borderLeftWidth: 6,
      padding: "4px !important", // override inline-style
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "green",
      borderWidth: 2,
      padding: "4px !important", // override inline-style
    },
    "& .Mui-focused": {
      // border: "2px solid red",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "green",
        borderLeftWidth: 6,
      },
    },
  },
}));
